import { render, staticRenderFns } from "./FormatBoldIcon.vue?vue&type=template&id=32ead506"
import script from "./FormatBoldIcon.vue?vue&type=script&lang=js"
export * from "./FormatBoldIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports